<template>
    <div class="register-upload">
        <el-upload
                :disabled="disabled"
                v-bind="$attrs"
                :class="['upload-demo', {'upload-disabled': disabled}]"
                :accept="accept"
                action="upload"
                :before-upload="getUploadInfo"
                :http-request="submitUpload"
                :show-file-list="false"
                >
            <i :class="[iconShow, 'upload_icon']" v-if="uploadDisplayType === 'icon'"></i>
            <i :class="[iconShow]" v-if="uploadDisplayType === 'iconAndText'"></i>
            <el-button class="upload_button" :disabled="disabled" size="small" type="primary" v-if="uploadDisplayType === 'button'" :loading="loading">{{text}}</el-button>
            <span :class="[disabled ? textDisabled: '', 'upload_text']" v-if="uploadDisplayType === 'text'" v-html="text"></span>
            <span :class="[disabled ? textDisabled: '', 'upload_text']" v-if="uploadDisplayType === 'iconAndText'" v-html="text"></span>
        </el-upload>
    </div>
</template>

<script>
import { ossUpload, ocrUpload, uploadFileWithOcr } from '../../api/uploadAndDownload.js';
// import { dictWithUrl } from '@/components/lots/api';
import { OSS_FILE_MAX_SIZE, SRM_FILE_MAX_SIZE } from '../../constant/constant.js';
// import config from '@/config/user.env';

// const DEFAULT_MAX_SIZE = 20 // 文件控制默认大小
const THOUSAND_TWENTY_FOUR = 1024;
const TEN = 10;
export default {
    props: {
        bucket: {
            type: String,
            default() {
                return 'srm';
            }
        },
        text: {
            type: String,
            default() {
                return '';
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            default() {
                return 'icon iconfont iconicon_export';
            }
        },
        uploadDisplayType: {
            type: String,
            default() {
                return 'icon';
            }
        },
        accept: {
            type: String, // 推荐用户上传什么类型的文件
            default() {
                return '';
            }
        },
        flag: {
            type: [String, Number, Boolean, Object, Array]
        },
        fileLimit: {
            type: Object, // 限制用户不能上传什么类型的文件
            default() {
                return {};
            }
        },
        ocr: {
            type: String, // 可接收字符串见README.md文档
            default() {
                return '';
            }
        },
        isBringOut: {
            type: Boolean,
            default() {
                return false;
            }
        },
        typeLimit: {
            type: Object, // 控制非ocr上传情况下的文件类型
            default() {
                return {};
            }
        },
        businessKey: { // 业务分组
            type: String,
            default: ''
        },
        publicRead: { // 公有读标识 0私有，1公有
            type: [Number, String],
            default: 1
        },
        // 250410限制OSS上传文件大小为30MB，OCR上传文件大小为15MB
        // sizeLimit: {
        //     type: [Number, String],
        //     default() {
        //         return 0;
        //     }
        // },
        fileTypeReg: { // 文件后缀校验
            type: RegExp,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            iconDisabled: 'icon-disabled',
            textDisabled: 'text-disabled',
            iconShow: this.icon,
            contentLength: 0,
            uploadName: '',
            // appid: config.uploadAppId,
            // appkey: config.uploadAppKey,
            fileType: '',
            // dictData: {},
        };
    },
    methods: {
        // 文件名处理
        handleFileNameAndSize(file) {
            const index = file.name.lastIndexOf('.');
            const originName = file.name.substring(0, index).replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/ig, '').replace(/\s+/g, '');
            const originNameType = file.name.substring(index, file.length);
            // this.uploadName = originName + '_' + new Date().getTime() + originNameType;
            this.uploadName = originName + originNameType;
            this.contentLength = file.size;
        },
        getUploadInfo(file) {
            this.handleFileNameAndSize(file);
            // 不允许上传不可预览格式文件
            // 需要对接ocr的 只允许上传jpg/png/jepg
            let uploadTypeReg;
            this.fileType = file.name.slice(file.name.lastIndexOf('.'));
            if (this.ocr) {
                uploadTypeReg = /\.(jpg|jpeg|png)$/;
            } else if (this.fileTypeReg) {
                uploadTypeReg = this.fileTypeReg;
            } else {
                uploadTypeReg = /\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga|doc|docx|xls|xlsx|ppt|pptx|pdf|txt)$/;
            }
            if (!uploadTypeReg.test(this.fileType.toLowerCase())) {
                if (this.ocr) {
                    this.$message.warning(`此处只支持上传${SRM_FILE_MAX_SIZE}M以内的jpg、jpeg、png格式文件`);
                } else {
                    this.$message.warning('不支持上传' + this.fileType + '格式文件');
                }
                return false;
            }
            // ocr 文件大小限制
            if (this.ocr) {
                if (file.size > SRM_FILE_MAX_SIZE * THOUSAND_TWENTY_FOUR * THOUSAND_TWENTY_FOUR) {
                    this.$message.warning(`上传文件不能大于${SRM_FILE_MAX_SIZE}MB`);
                    return false;
                }
            } else {
                // // 通过字典获取文件大小最大限制
                // const MAX_SIZE = this.dictData.SRM_UPLOAD_FILE_CONFIG ? Number(this.dictData.SRM_UPLOAD_FILE_CONFIG.MAX_SIZE) : DEFAULT_MAX_SIZE
                if (file.size > OSS_FILE_MAX_SIZE * THOUSAND_TWENTY_FOUR * THOUSAND_TWENTY_FOUR) {
                    this.$message.warning(`上传文件不能大于${OSS_FILE_MAX_SIZE}MB`);
                    return false;
                }
            }
            if (!this.ocr) {
                const isLimit = file.type === this.fileLimit.type;
                if (this.fileLimit.type && isLimit) {
                    this.$message.warning(this.fileLimit.message);
                }
                return !isLimit;
            }
        },
        submitUpload(uploadData) {
            // ocr上传
            if (this.ocr) {
                const formData = new FormData();
                const file = new File([uploadData.file], this.uploadName, {
                    type: uploadData.file.type
                });
                formData.append('file', file);
                if (this.isBringOut) { formData.append('isBringOut', this.isBringOut); }
                switch (this.ocr) {
                case 'idCardFont': formData.append('type', 'idcard'); break;
                case 'idCardBehind': formData.append('type', 'idcard'); break;
                case 'vehicle': formData.append('type', 'vehicle'); break;
                case 'driving': formData.append('type', 'driving'); break;
                case 'delegate': formData.append('type', 'delegate'); break;
                case 'businessLicense': formData.append('type', 'businessLicense'); break;
                }
                const ocrReq = this.ocr === 'businessLicense' ? uploadFileWithOcr : ocrUpload;
                this.loading = true
                ocrReq(formData).then(res => {
                    if (res && res.code === '0') {
                        this.$emit('uploadSuccess', { data: res.data, flag: this.flag, ocr: this.ocr });
                    }
                }).catch(err => {}).finally(() => { this.loading = false });
                return;
            }
            // oss上传
            if (JSON.stringify(this.typeLimit) !== '{}' && !new RegExp(this.typeLimit.reg).test(this.fileType.toLowerCase())) {
                this.$message.warning('上传文件只限' + this.typeLimit.warningText + '格式');
                return;
            }
            this.$emit('beforeUpload', uploadData);
            // // 通过字典获取文件大小最大限制
            // const MAX_SIZE = this.dictData.SRM_UPLOAD_FILE_CONFIG ? Number(this.dictData.SRM_UPLOAD_FILE_CONFIG.MAX_SIZE) : DEFAULT_MAX_SIZE
            // if (this.sizeLimit && uploadData.file.size > Number(this.sizeLimit) * THOUSAND_TWENTY_FOUR * THOUSAND_TWENTY_FOUR) {
            //     this.$message.warning(`文件大小不能超过 ${this.sizeLimit}MB`);
            // } else if (uploadData.file.size > MAX_SIZE * THOUSAND_TWENTY_FOUR * THOUSAND_TWENTY_FOUR) {
            // 250410限制OSS上传文件大小为30MB
            if (uploadData.file.size > OSS_FILE_MAX_SIZE * THOUSAND_TWENTY_FOUR * THOUSAND_TWENTY_FOUR) {
                this.$message.warning(`文件大小不能超过 ${OSS_FILE_MAX_SIZE}MB`);
            } else if (this.amazon_escape(this.uploadName)) {
                this.$message.warning(`文件名不能包含下列任何字符：? / \ * | " < >`);
            } else {
                this.simpleUpload(uploadData);
            }
        },
        async simpleUpload(uploadData) {
            const file = new File([uploadData.file], this.uploadName, {
                type: uploadData.file.type
            });
            this.loading = true
            ossUpload(file, {
                bucket: this.bucket,
                businessKey: this.businessKey,
                publicRead: this.publicRead,
                callback: null
            }).then((res) => {
                if (res && +res.code === 0) {
                    res.data.downUrl = decodeURIComponent(res.data.downUrl);
                    const lastPoint = res.data.downUrl.lastIndexOf('.');
                    // const lastLine = res.data.downUrl.lastIndexOf('_');
                    // const lastslash = res.data.downUrl.lastIndexOf('/');
                    // res.data.id = res.data.downUrl.slice(lastLine + 1, lastPoint);
                    // 0627 OSS版本升级，使用当前时间戳作id
                    res.data.id = (new Date()).getTime();
                    // 241205 修改，将当前文件的名称作为localFileName
                    // res.data.localFileName = res.data.downUrl.slice(lastslash + 1, lastLine) + res.data.downUrl.slice(lastPoint);
                    res.data.localFileName = file.name
                    res.data.type = res.data.downUrl.slice(lastPoint + 1);
                    this.$emit('uploadSuccess', { data: res, flag: this.flag });
                }
            }).catch(err => {}).finally(() => {
                this.loading = false
                this.$emit('afterUpload')
            });
        },
        // 除了下面这些字符外，其它都可以上传，参考oss接口上传文档
        _amazon_should_escape(c) {
            const specialList = ['?', '/', '\\', '*', '|', '"', '<', '>'];
            return specialList.includes(c);
        },
        // 对文件名称特殊字符进行转换，否则会报接口异常
        amazon_escape(name) {
            let hexCount = 0;
            for (let i = 0; i < name.length; i++) {
                const c = name.charAt(i);
                if (this._amazon_should_escape(c)) {
                    hexCount = hexCount + 1;
                }
            }
            if (hexCount === 0) {
                return false;
            } else {
                let ret = '';
                for (let i = 0; i < name.length; i++) {
                    const char = name.charAt(i);
                    if (this._amazon_should_escape(char)) {
                        ret += char;
                    }
                }
                ret = [].filter.call(ret, (s, i, o) => o.indexOf(s) === i).join('');
                return ret;
            }
        }
    },
    // mounted() {
    //     dictWithUrl('SRM_UPLOAD_FILE_CONFIG').then(res => {
    //         if (res && +res.code === 0) {
    //             this.dictData = res.data
    //         }
    //     })
    // },
};
</script>
<style lang="less">
    .register-upload {
        .icon-disabled,
        .text-disabled {
            cursor: not-allowed;
        }

        .upload-disabled .el-upload {
            cursor: not-allowed;
            opacity: 0.5;
        }
    }
</style>
